import { useMailMessage } from "@/hooks/useMailMessage";
import type { MailMessageSummary } from "@/lib/types/mail";

export function useMobileMessage(
  accountId: number | null,
  folder: string,
  uid: number | null,
  headerPreview?: MailMessageSummary | null
) {
  return useMailMessage(accountId ?? undefined, uid, folder, headerPreview);
}
